import { render } from "./SecondaryNav.vue?vue&type=template&id=47ead156&scoped=true"
import script from "./SecondaryNav.vue?vue&type=script&lang=js"
export * from "./SecondaryNav.vue?vue&type=script&lang=js"

import "./SecondaryNav.vue?vue&type=style&index=0&id=47ead156&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47ead156"]])

export default __exports__